import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NumberFormatter } from '../../pipes/currency-pipe';
import { IOrder } from '../../model/models/order/order-interface';

@Component({
  selector: 'rmt-home-continue-transfer',
  templateUrl: 'rmt-home-continue-transfer.html'
})
export class RmtHomeContinueTransferComponent implements OnChanges {
  @Input() order: IOrder = null;
  @Input() dateLabel: string = '';
  @Output() continueTransfer = new EventEmitter<void>();
  recipientName: string = '';
  amountLabel: string = '';
  countryTo: string = '';

  constructor(private translate: TranslateService, private currencyFormatter: NumberFormatter) { }

  ngOnChanges() {
    const order: IOrder = this.order || {};
    const recipient = order.recipient;
    this.recipientName = recipient && (recipient.firstName || recipient.lastName1)
      ? `${recipient.firstName || ''} ${recipient.lastName1 || ''}`.trim()
      : this.translate.instant('page.activityPage.recipientUnknownLabel');
    const amount = order.amountFrom ? this.currencyFormatter.transform(order.amountFrom, order.currencyFrom) : '';
    this.amountLabel = amount ? `${amount} ${order.currencyFrom || ''}`.trim() : '';
    this.countryTo = (order.countryTo || '').toUpperCase();
  }

  getFlagUrl(country: string): string {
    return 'assets/countryFlagSvg/' + country + '.svg';
  }

  onContinue(event?: Event) {
    if (event)
      event.preventDefault();
    this.continueTransfer.emit();
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-home-continue-transfer/rmt-home-continue-transfer.ts